<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" sm="12">
        <v-breadcrumbs :items="breadcrumbs" small>
          <template v-slot:divider>&rsaquo;</template>
          <template v-slot:item="props">
            <template v-if="props.item.icon">
              <v-breadcrumbs-item :to="props.item.to" :disabled="props.item.disabled">
                <v-icon small>{{props.item.icon}}</v-icon>
              </v-breadcrumbs-item>
            </template>

            <template v-else>
              <v-breadcrumbs-item
                :to="props.item.to"
                :disabled="props.item.disabled"
                exact
                small
              >{{ props.item.text }}</v-breadcrumbs-item>
            </template>
          </template>
        </v-breadcrumbs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "page-header",
  computed: {
    breadcrumbs() {
      return this.reduceBreadcrumbs();
    }
  },
  methods: {
    mountBreadcrumbs(matched) {
      if (matched.parent) {
        this.mountBreadcrumbs(matched.parent);
      }

      return {
        to: matched.name === this.$route.name ? this.$route.path : matched.path,
        text: matched.meta.breadcrumb || matched.path,
        disabled: false
      };
    },
    reduceBreadcrumbs() {
      return this.$route.matched.reduce(
        (breadcrumbList, matched, i) => {
          if (matched.meta.breadcrumb) {
            breadcrumbList.push(this.mountBreadcrumbs(matched));
          }

          return breadcrumbList;
        },
        [
          {
            to: "/",
            icon: "home",
            disabled: false
          }
        ]
      );
    }
  }
});
</script>

<style lang="scss" scoped>
.container {
  background: #fff;
  padding: 0px;
}
.v-breadcrumbs {
  padding: 10px;
  border-bottom: solid 1px #f0f0f0;
}
</style>
